export default __webpack_public_path__ + "static/avatar-tag-anatomy-light-91ecddfc15171e13ffc712c136a4dcd3.png";